import type { Dict } from "../core.js";
import type { components as vi } from "../vi/components.js";

export const components: Dict<typeof vi> = {
  "quality.approx": "Estimated",
  "quality.stale": "Stale",
  "quality.missing": "No data",
  "quality.drift": "Schema drift",
  "quality.unsupported": "Not supported",
  "quality.not_configured": "Not configured",
  basisMissing: "No measurement basis declared.",
  basis: "Basis: {basis}",
  basisWithDesc: "Basis “{basis}”: {desc}",
  valueAt: "Value as of {at}",
  updatedAt: "Updated {at}",
  // AppBreakdown
  "breakdown.title": "By app",
  "breakdown.viewOne": "View {name} only",
  "breakdown.count": "{measured}/{total} apps reporting",
  "breakdown.search": "Search apps…",
  "breakdown.app": "App",
  "breakdown.updated": "Updated",
  "breakdown.noMatch": "No app matches.",
  "breakdown.noData": "{count} apps with no data yet",
  "breakdown.total": "Total",
  "breakdown.new": "New",
  "breakdown.active": "Active",
  // AppFilter
  "appFilter.ariaLabel": "Choose app",
  "viewing.prefix": "Viewing:",
  "viewing.single": "— figures for this app only.",
  // PeriodSelect
  "periodSelect.ariaLabel": "Period",
  "periodSelect.from": "From",
  "periodSelect.to": "To",
  "periodSelect.reversed": "Start date must be before end date.",
  // SeriesChart
  "chart.emptyBefore": "No data yet for",
  "chart.emptyAfter": "in this period.",
  "chart.noData": "{date}: no data",
  "chart.approx": " (estimate — sum of sources, shared users may be counted twice)",
  "chart.stale": " (as of {at})",
  "chart.unknown": "unknown",
};
